import _ from "underscore";

import { ORGANIZATION_USERS_LOADED, OrganizationUsersLoadedEvent } from "../../../events/loaded/organizations/organazation_users_loaded";

import type { ApiUserForOrganization, ApiUserPermission } from "avvir";
import type { Reducer } from "redux";
import { USER_PERMISSIONS_BY_ID_LOADED, UserPermissionsByIdLoadedEvent } from "../../../events/auth_events/user_permissions_by_id_loaded";
import { ORGANIZATION_MEMBER_REMOVED, OrganizationMemberRemovedEvent } from "../../../events/superadmin/organization_member_removed";

export type OrganizationUserEvents =
  | OrganizationUsersLoadedEvent
  | UserPermissionsByIdLoadedEvent
  | OrganizationMemberRemovedEvent

export type OrganizationUserStore = { users: ApiUserForOrganization[], permissions: { [id: number]: ApiUserPermission } }

const reduceOrganizationUsers: Reducer<OrganizationUserStore, OrganizationUserEvents> = (usersStore = { users: [], permissions: {} }, event) => {
  switch (event?.type) {
    case ORGANIZATION_USERS_LOADED: {
      return {
        ...usersStore,
        users: event.payload.users
      };
    }
    case ORGANIZATION_MEMBER_REMOVED: {
      const { memberId } = event.payload;
      return {
        ...usersStore,
        users: usersStore.users.filter((user) => user.id !== memberId)
      };
    }
    default:
      return usersStore;
  }
};

export default reduceOrganizationUsers;
